/**
 * 子育て応援席以外の専用席があるかどうかを判定
 */
export function hasOtherExclusiveType(list) {
  if (!list.cars_formation?.cars) return false;
  return list.cars_formation.cars.some(
    (car) =>
      car.exclusive_type &&
      car.exclusive_type !== "A" &&
      car.exclusive_type.trim() !== ""
  );
}

/**
 * 子育て応援席以外の専用席名を取得
 */
export function getOtherExclusiveTypeName(list) {
  if (!list.cars_formation?.cars) return "";
  const car = list.cars_formation.cars.find(
    (car) =>
      car.exclusive_type &&
      car.exclusive_type !== "A" &&
      car.exclusive_type.trim() !== ""
  );
  return car ? car.exclusive_car_name || "" : "";
}
